module.exports = __webpack_public_path__ + "static/media/link.918483af.svg";